module.exports = __webpack_public_path__ + "99a22c7aa37b1196dc514439a9d4d874.svg";